import { useNavigate } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { apiInstance } from "./axios";
import cogoToast from "cogo-toast";

// Get Data
const fetchData = async (url, data, navigate) => {
  try {
    const requestBody = data !== undefined ? data : {};
    const response = await apiInstance.post(url, requestBody);

    if (response.status === 200) {
      return response.data;
    } else {
      cogoToast.error(response.data.message || "Something went wrong!");
      throw new Error(response.data.message || "Error fetching data");
    }
  } catch (error) {
    // console.error("Get Error:", error);
    // cogoToast.error(error.response?.data?.message || error.message);
    // if (error.response?.status === 401) {
    // cogoToast.error("Unauthorized access");
    // setTimeout(() => {
    //   navigate("/logout");
    //   cogoToast.info("Please sign in again!");
    // }, 500);
    // }
    throw error;
  }
};
const useFetchData = (queryKey, url, data, id, options = {}) => {
  const navigate = useNavigate();

  return useQuery({
    queryKey: [queryKey, id],
    queryFn: () => fetchData(url, data, navigate),
    // onError: (error) => {
    //   if (error.response?.status === 401) {
    //     cogoToast.error("Unauthorized access");

    //     setTimeout(() => {
    //       navigate("/logout");
    //       cogoToast.info("Please sign in again!");
    //     }, 500);
    //   }
    // },
    staleTime: 1000 * 60 * 5,
    retry: false,
    refetchOnWindowFocus: false,
    ...options,
  });
};

const usePostApiRequest = () => {
  const queryClient = useQueryClient();

  // const navigate = useNavigate();

  // const handleLogout = () => {
  //   cogoToast.error("Unauthorized access");

  //   setTimeout(() => {
  //     navigate("/logout");
  //     cogoToast.info("Please sign in again!");
  //   }, 500);
  // };

  const postApiFunction = async ({
    url,
    method = "POST",
    data = {},
    queryKey,
    onSuccess,
    onError,
    noToast,
  }) => {
    try {
      const response = await apiInstance({
        method,
        url,
        data,
      });

      if (response.status === 200) {
        const successMessage = response.data.Message || "Request successful!";
        if (!noToast) {
          cogoToast.success(successMessage);
        }

        if (queryKey) {
          queryClient.invalidateQueries({
            queryKey: queryKey,
            exact: false,
          });
        }

        if (onSuccess) onSuccess(response.data);
        return response.data;
      } else {
        const errorMsg = response.data.Message || "Something went wrong!";
        cogoToast.error(errorMsg);
        throw new Error(errorMsg);
      }
    } catch (error) {
      // if (error.response && error.response.status === 401) {
      // handleLogout();
      // } else {
      // cogoToast.error("An unknown error occurred!");
      // if (onError) onError(error);
      // }
    }
  };

  return postApiFunction;
};

export { useFetchData, usePostApiRequest };
